import React from 'react';
import { translations } from '../data/translations';
import { useLanguage } from '../context/LanguageContext';

function Savings() {
  const { t } = useLanguage();

  return (
    <section id="savings" className="savings">
      <div className="container">
        <h2 className="section-title">{t(translations.savings.title)}</h2>
        <p className="section-subtitle">{t(translations.savings.subtitle)}</p>

        <div className="savings-highlight">
          <span className="savings-highlight-icon">{'\u26A1'}</span>
          <span className="savings-highlight-text">{t(translations.savings.keyPoint)}</span>
        </div>

        <div className="savings-grid">
          <div className="savings-card">
            <div className="savings-card-header">
              <span className="savings-card-icon">{'\u{1F6CF}\uFE0F'}</span>
              <h3>{t(translations.savings.example1Title)}</h3>
            </div>
            <div className="savings-card-body">
              <div className="savings-spec">
                <span className="savings-label">{t(translations.savings.example1Model)}</span>
              </div>
              <div className="savings-spec">
                <span className="savings-label">{t(translations.savings.example1Consumption)}</span>
              </div>
              <div className="savings-cost">
                <span>{t(translations.savings.example1Cost)}</span>
              </div>
            </div>
          </div>

          <div className="savings-card">
            <div className="savings-card-header">
              <span className="savings-card-icon">{'\u{1F6CB}\uFE0F'}</span>
              <h3>{t(translations.savings.example2Title)}</h3>
            </div>
            <div className="savings-card-body">
              <div className="savings-spec">
                <span className="savings-label">{t(translations.savings.example2Model)}</span>
              </div>
              <div className="savings-spec">
                <span className="savings-label">{t(translations.savings.example2Consumption)}</span>
              </div>
              <div className="savings-cost">
                <span>{t(translations.savings.example2Cost)}</span>
              </div>
            </div>
          </div>

          <div className="savings-card">
            <div className="savings-card-header">
              <span className="savings-card-icon">{'\u{1F6C1}'}</span>
              <h3>{t(translations.savings.example3Title)}</h3>
            </div>
            <div className="savings-card-body">
              <div className="savings-spec">
                <span className="savings-label">{t(translations.savings.example3Model)}</span>
              </div>
              <div className="savings-spec">
                <span className="savings-label">{t(translations.savings.example3Consumption)}</span>
              </div>
              <div className="savings-cost">
                <span>{t(translations.savings.example3Cost)}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="savings-comparison">
          <p className="savings-comparison-text">{t(translations.savings.comparison)}</p>
        </div>

        <p className="savings-note">{t(translations.savings.note)}</p>
      </div>
    </section>
  );
}

export default Savings;
